angular.module('tgaApp')
  .filter('unsafe', ['$sce', function ($sce) {
    return function (val) {
      return $sce.trustAsHtml(val);
    };
  }])
  .filter('trustUrl', [
    '$sce',
    function ($sce) {
      return function (recordingUrl) {
        return $sce.trustAsResourceUrl(recordingUrl);
      };
    },
  ])
  .filter('formatDuration', () => function (input) {
    let result = '';
    const totalSeconds = input / 1000;
    const totalMinutes = totalSeconds / 60;
    const totalHours = totalMinutes / 60;
    let seconds = Math.floor(totalSeconds) % 60;
    let minutes = Math.floor(totalMinutes) % 60;
    const hours = Math.floor(totalHours) % 60;

    if (hours !== 0) {
      result += `${hours}:`;

      if (minutes.toString().length === 1) {
        minutes = `0${minutes}`;
      }
    }

    result += `${minutes}:`;

    if (seconds.toString().length === 1) {
      seconds = `0${seconds}`;
    }

    result += seconds;

    return result;
  })
  .filter('percentage', [
    '$filter',
    function ($filter) {
      return function (input, decimals) {
        return `${$filter('number')(input * 100, decimals)}%`;
      };
    },
  ])
  .filter('parseDate', () => function (date) {
    // var t = date.split(/[- :]/);
    // return new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
    return Date.parse(date) || Date.parse(date.replace('-', '/', 'g'));
  })
  .filter('userType', () => function (input) {
    switch (input) {
      case 'super_admin':
        return 'Super Admin';
      case 'admin':
        return 'Admin';
      case 'user':
        return 'Viewer';
      case 'player':
        return 'Player';
      case 'team':
        return 'Team';
      default:
        return input;
    }
  })
  .filter('titleCase', () => function (input) {
    const s = input || '';
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  })
  .filter('sumProperty', () => function (data, key) {
    if (angular.isUndefined(data) || angular.isUndefined(key)) {
      return 0;
    }

    let sum = 0;

    angular.forEach(data, (value) => {
      sum += parseInt(value[key], 10);
    });

    return sum;
  })
  .filter('capitalize', () => function (input) {
    return input ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
  })
  .filter('getProperty', () => function (data, key, unique) {
    const products = data;
    let output = [];

    for (let i = 0; i < products.length; i++) {
      output.push(products[i][key]);
    }

    if (unique) {
      output = _.uniq(output);
    }

    return output.join(', ');
  })
  .filter('nbsp', () => function (val) {
    let v = val;
    if (val.toString) {
      v = val.toString();
    }
    return v.replace(/ /g, '\u00a0');
  })
  .filter('trim', () => function (input) {
    return input.trim();
  })
  .filter('trimLower', () => function (input) {
    return input.trim().toLowerCase();
  })
  .filter('noWrapReplaceAll', () => function (val, arr, tag = 'span') {
    let v = val;
    if (val.toString) {
      v = val.toString();
    }
    for (let i = 0; i < arr.length; i += 1) {
      const str = `<${tag} style="white-space:nowrap;">${arr[i]}</${tag}>`;
      v = v.replace(new RegExp(arr[i], 'g'), str);
    }
    return v;
  })
  .filter('cut', () => function (value, wordwise, max, tail) {
    if (!value) return '';

    let v = value.toString();

    const m = parseInt(max, 10);
    if (!m) return v;
    if (v.length <= m) return v;

    v = v.substr(0, m);
    if (wordwise) {
      let lastspace = v.lastIndexOf(' ');
      if (lastspace !== -1) {
        // Also remove . and , so its gives a cleaner result.
        if (v.charAt(lastspace - 1) === '.' || v.charAt(lastspace - 1) === ',') {
          lastspace -= 1;
        }
        v = v.substr(0, lastspace);
      }
    }

    return v + (tail || ' …');
  });
